/* eslint no-var: 0 */
/* eslint quote-props: 0 */
/* eslint prefer-template: 0 */
/* eslint no-else-return: 0 */
import merge from 'lodash/merge';

import type { SeriesOptionsType, Options, TooltipOptions, DataLabelsOptionsObject } from "highcharts";

export default {
  cxp_filters: {
    "Eingestellten": {hired: true},
    "Eingeladenen": {took_part_selection_process: true},
    "Abgesagten": {hired: false},
    "Ohne Feedback": {without_feedback: true}
  },
  interview_form: {
    graphological: "Graphologisches Gutachten",
    unstructured: "Unstrukturiertes Einzelgespräch: Strukturiertes Einzelgespräch (Interviewer hatte einen Leitfaden)",
    assessment_center: "Assessment Center vor Ort beim Unternehmen (Sie wurden bei Aufgaben/Situationen beobachtet)",
    e_assessment_center: "E-Assessment Center durch Online-Aufgaben",
    recruitainment: "Recruitainment (spielerischer Eignungstest)",
    group_sessions_with_applicants: "Gruppengespräch mit mehreren Bewerbern gleichzeitig",
    group_sessions_with_watchers: "Gruppengespräch mit mehreren Beobachtern gleichzeitig",
    tests: "Tests (Intelligenztests, Persönlichkeitstest, Leistungstest)",
    work_samples: "Arbeitsproben (Sie mussten eine Aufgabe lösen, die Sie für die Stelle ausüben müssen)",
    self_evaluation_questionaire: "Selbstbeschreibungsfragebogen",
  },
  degree: {
    "0,1": "ohne Abschluss, Mittelschulabschluss",
    "2,3": "Facharbeiter, Abitur",
    "5,10": "Bachelor, Techniker",
    "6,7,8,4": "Diplom, Master, Staatsexamen, Master, Meister",
    "9": "Promotion",
  },
  employee_types: {
    "1": "Führungskraft",
    "2": "Mitarbeiter",
    "3": "Student/Schüler",
  },
  ages: ["<21", "21-30", "31-40", "41-50", ">50"],
  colors: {
    own: ["#5cb64d", "#408135", '#8ecc83'],
    community: ["#9e47ef", "#5c2f84", "#522a76", "#492569", "#40205c", "#371c4f", "#2e1742", "#241234", "#1b0e27", "#6c4390", "#7c589c", "#8c6da8", "#9d82b5", "#ad97c1", "#bdabcd", "#b16bf2", "#bb7ef3"]
  },
  cxp_color(type: string) {
    switch (type) {
      case "before_application":
        return ["#67a5ce", "#43708c", "#67a5ce", "#5c94b9", "#5284a4", "#487390", "#3d637b", "#335267", "#294252", "#1e313d", "#142129"];
      case "first_contact":
        return ["#67ce89", "#3f935a", "#388451","#327548","#2c663e","#255836","#1f492d","#193a24","#122c1b", "#76aed2", "#85b7d7", "#94c0dc", "#a3c9e1", "#b3d2e6", "#c2dbeb"];
      case "interview":
        return ["#ce6f67", "#7f4843", "#71403c", "#633834", "#55302d", "#472825", "#38201e", "#2a1816", "#1c100f", "#d27d76", "#d78b85", "#dc9a94", "#e1a8a3", "#e6b7b3", "#ebc5c2", "#f0d3d1"];
      case "rejection":
        return ["#ce9a67", "#936c48", "#846140", "#755639", "#664b32", "#58402b", "#493624", "#3a2b1c", "#2c2015", "#d2a476", "#d7ae85", "#dcb894", "#e1c2a3", "#e6ccb3", "#ebd6c2", "#f0e0d1", "#f5eae0"];
      case "acceptance":
        return ["#cecb67", "#9b984d", "#8b8845", "#7c793d", "#6c6a35", "#5d5b2e", "#4d4c26", "#3e3c1e", "#2e2d17", "#d2d076", "#d7d585", "#dcda94", "#e1dfa3", "#e6e5b3", "#ebeac2", "#f0efd1"];
      default:
        return [];
        // "#c2c2c2", "#939393"
    }
  },
  baseChart(percent: boolean, series: SeriesOptionsType[], chart: Options) {
    const base = {
      title: { text: null },
      credits: { enabled: false },
      xAxis: {
        title: { text: null }
      },
      tooltip: {
        pointFormat: percent ?
          `<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>` :
          `<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>`
      },
      yAxis: {
        title: { text: null },
        allowDecimals: false,
        labels: {
          format: percent ? "{value}%" : "{value}"
        }
      },
      legend: { enabled: false },
      series
    }
    return merge(base, chart)
  },

  chartTemplates: {
    dataLabels(percent: boolean): DataLabelsOptionsObject {
      return {
        enabled: true,
        padding: 0,
        inside: false,
        formatter() {
          const y = Math.round(Math.abs(this.y ?? 0) * 10) / 10;
          if (y === 0) {
            return ""
          }
          if (percent) {
            return y + "%";
          } else {
            return y;
          }
        },
        style: {
          fontWeight: 'normal',
          fontSize: '9px',
          textOutline: "1px #fff",
          color: '#333'
        }
      }
    },
    unstackedTooltip(percent: boolean): TooltipOptions {
      return {
        shadow: false,
        borderRadius: 0,
        backgroundColor: 'none',
        borderWidth: 0,
        useHTML: true,
        pointFormatter() {
          const value = this.y ? Math.abs(this.y) : 0;
          if (percent) {
            return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${value}%</b><br/>`
          } else {
            return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${value}</b><br/>`
          }
        }
      }
    },
    sharedStackTooltip(percent: boolean): TooltipOptions {
      return {
        shared: true,
        shadow: false,
        borderRadius: 0,
        backgroundColor: 'none',
        borderWidth: 0,
        useHTML: true,
        formatter() {
          if (!this.points) return
          var tooltip = `<table class="tip"><tbody>`;
          this.points.forEach((point) => {
            const color = point.color || point.series.color
            tooltip += `<tr><th><span style="color: ${color}">\u25CF</span> ${point.series.name}</th>`
            if (percent || point.series.name.indexOf('Anteil') !== -1 || point.series.name.indexOf('quote') !== -1) {
              tooltip += `<td style="text-align: right">${Math.abs(point.y)}%</td></tr>`
            } else {
              tooltip += `<td style="text-align: right">${Math.abs(point.y)}</td></tr>`
            }
          });
          tooltip += '</tbody></table>';
          return tooltip;
        }
      }
    }
  }
}
